import { ArrowTrendingLines24Regular, Money24Regular, Target24Regular, Trophy24Regular } from '@fluentui/react-icons';
import { QueryAggregate } from '@powerportalspro/core';
import { useT } from '@powerportalspro/react';
import { MainGrid, SummaryCard, SummaryCards } from '@powerportalspro/react-fluent';
import { useMemo, useState } from 'react';
import {
  OPEN_OPPORTUNITIES_VIEW_ID,
  CLOSED_OPPORTUNITIES_FETCH_XML,
  OPEN_OPPORTUNITIES_FETCH_XML,
  WON_OPPORTUNITIES_FETCH_XML,
  getOpenOpportunitiesView,
} from '../demos/DetailPageRecords';

const STRINGS_BASE =
  'components.PowerPortalsPro.Demo.Client.Customizations.Pages.Layout.SummaryCard.SummaryCardMainDemo';

// Four figures over every deal in the portal, each worked out by Dataverse and formatted by the
// server: the open pipeline with how many deals make it up, the average open deal, the revenue
// won, and the share of closed deals that were won. Clicking the pipeline lists its deals.
export function SummaryCardMainSample() {
  const t = useT();
  const [showOpenDeals, setShowOpenDeals] = useState(false);
  // The open deals, by the view the detail pages list them in.
  const views = useMemo(() => [getOpenOpportunitiesView(t(`${STRINGS_BASE}.open-view`))], [t]);

  return (
    <>
      <SummaryCards>
        <SummaryCard
          icon={<ArrowTrendingLines24Regular />}
          label={t(`${STRINGS_BASE}.pipeline`)}
          fetchXml={OPEN_OPPORTUNITIES_FETCH_XML}
          columnName="estimatedvalue"
          aggregate={QueryAggregate.Sum}
          format="C0"
          caption={t(`${STRINGS_BASE}.open-deals`)}
          captionAggregate={QueryAggregate.Count}
          onClick={() => setShowOpenDeals((shown) => !shown)}
        />
        <SummaryCard
          icon={<Money24Regular />}
          label={t(`${STRINGS_BASE}.average-deal`)}
          fetchXml={OPEN_OPPORTUNITIES_FETCH_XML}
          columnName="estimatedvalue"
          aggregate={QueryAggregate.Average}
          format="C0"
        />
        <SummaryCard
          icon={<Trophy24Regular />}
          label={t(`${STRINGS_BASE}.won`)}
          fetchXml={WON_OPPORTUNITIES_FETCH_XML}
          columnName="actualvalue"
          aggregate={QueryAggregate.Sum}
          format="C0"
          caption={t(`${STRINGS_BASE}.won-deals`)}
          captionAggregate={QueryAggregate.Count}
        />
        <SummaryCard
          icon={<Target24Regular />}
          label={t(`${STRINGS_BASE}.win-rate`)}
          fetchXml={WON_OPPORTUNITIES_FETCH_XML}
          ofFetchXml={CLOSED_OPPORTUNITIES_FETCH_XML}
          aggregate={QueryAggregate.Count}
        />
      </SummaryCards>

      {showOpenDeals && (
        <MainGrid
          tableName="opportunity"
          maxHeight="400px"
          viewIds={[OPEN_OPPORTUNITIES_VIEW_ID]}
          customViewDefinitions={views}
          defaultViewId={OPEN_OPPORTUNITIES_VIEW_ID}
        />
      )}
    </>
  );
}
